<div class="account-container" [ngClass]="{ 'employee-view': isEmployee }">
  <div class="account-container__spinner-wrapper" *ngIf="(authState$ | async)?.type !== loggedInState">
    <span class="loader"></span>
    <p class="account-container__spinner-wrapper__label">{{ 'PAGES.ACCOUNT.LOADING' | translate }}</p>
  </div>
  <app-base-wireframe *ngIf="(authState$ | async)?.type === loggedInState">
    <div *appShowFor="'mm-mobile'" wireframe-block="topbar" class="account-topbar">
      <app-topbar *ngIf="templateOptions.isChildPage" [backLinkUrl]="templateOptions.parentPage.path"></app-topbar>
    </div>
    <div
      wireframe-block="sidebar"
      *ngIf="
        !(
          (featureFlagShoppingList | async) &&
          templateOptions.isYourAssortmentPage &&
          (templateOptions.accountInfo$ | async)?.isSubsidiary
        ) &&
        !(templateOptions.isMobileView$ | async) &&
        !templateOptions.isAccessDeniedPage
      "
    >
      <ng-container *ngIf="(accountType$ | async) !== EMPLOYEE_AS_CUSTOMER && (accountType$ | async) !== EMPLOYEE">
        <ng-container *ngIf="featureFlagPaymentMethod | async">
          <app-account-side-bar-menu
            (supportClicked)="onSupportClick()"
            [isPaymentMethodPageVisible]="true"
            [currentPageUrl]="templateOptions?.absolutePageUrl"
            [accountInfo]="templateOptions?.accountInfo$ | async"

          >
          </app-account-side-bar-menu>
        </ng-container>
        <ng-container *ngIf="isStoredPaymentMethodPageDisabled">
          <app-account-side-bar-menu
            (supportClicked)="onSupportClick()"
            [isPaymentMethodPageVisible]="false"
            [currentPageUrl]="templateOptions?.absolutePageUrl"
            [accountInfo]="templateOptions?.accountInfo$ | async"
          >
          </app-account-side-bar-menu>
        </ng-container>
      </ng-container>
    </div>
    <div wireframe-block="main" class="account">
      <div class="employee-header" *ngIf="isEmployee">
        <h3 class="employee-header__title">
          {{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.COMPANY_NAME.TEXT' | translate }}:
          <b> {{ (customerInfo | async)?.organizationName }}</b>
        </h3>

        <div class="employee-header__buttons">
          <button
            (click)="handleStartWithNewCustomer($event)"
            mm-button
            [color]="'secondary'"
            [mmTestTarget]="'order-new-customer-button'"
          >
            {{ 'PAGES.AUTH.EMPLOYEE.SHARE_PAYMENT_LINK.DAILOG.START_WITH_NEW_CUSTOMER.BUTTON.TEXT' | translate }}
          </button>

          <button
            (click)="onEmployeeLogout()"
            mm-button
            [color]="'primary'"
            [mmTestTarget]="'order-employee-logout-button'"
          >
            {{ 'PAGES.AUTH.EMPLOYEE.SHARE_PAYMENT_LINK.DAILOG.EMPLOYEE_SIGN_OUT.BUTTON.TEXT' | translate }}
          </button>
        </div>
      </div>

      <div class="account__header" [mmTestId]="'ACCOUNT_PAGE.HEADER'">
        <div class="account__alert-container fn-account__alert-container"></div>
        <ng-container *appHideFor="'mm-mobile'">
          <app-back-link
            *ngIf="templateOptions.isChildPage"
            class="account__back-link"
            [link]="templateOptions.parentPage.path"
          >
            {{ templateOptions.parentPage.title | translate }}
          </app-back-link>
        </ng-container>

        <ng-container *ngIf="templateOptions.isPageTitleDisplayed">
          <div
            *ngIf="(templateOptions.isMobileView$ | async) ? !templateOptions.isChildPage : true"
            class="account-header"
          >
            <div class="account-header__page-name">
              <app-page-title></app-page-title>
            </div>

            <ng-container *ngIf="templateOptions.isAccountInfoPage">
              <div *ngIf="templateOptions.accountInfo$ | async; let accountInfo" class="account-header__account-data">
                <div class="account-header__account-id">
                  {{ 'PAGES.ACCOUNT.INFO.ACCOUNT_ID' | translate }}:
                  <span [mmTestTarget]="'account-number'">{{ accountInfo.accountNumber }}</span>
                </div>

                <div *ngIf="templateOptions.isEntrepreneur$ | async" class="account-header__status-badge-wrapper">
                  <span
                    *ngIf="templateOptions.accountInfo$ | async; let accountInfo"
                    [class]="
                      'account-header__status-badge account-header__status-badge--' + accountInfo?.status?.toLowerCase()
                    "
                    [mmTestTarget]="'account-status'"
                  >
                    {{ 'REGULAR.ACCOUNT_STATUSES.' + accountInfo.status | translate }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="account__content">
        <ng-container *ngIf="templateOptions.isTabsVisible">
          <div class="account__content__header-tabs" *ngIf="templateOptions.accountInfo$ | async; let accountInfo">
            <nav mat-tab-nav-bar>
              <div
                class="list-tab"
                [ngClass]="{ 'active-tab': templateOptions.isYourAssortmentPage }"
                *ngIf="
                  !(
                    accountInfo?.activeContext !== templateOptions.personalContext &&
                    templateOptions.isPersonalOrderHistoryPage
                  ) && (accountInfo?.isSubsidiary && featureFlagShoppingList | async)
                "
              >
                <a
                  mat-tab-link
                  [active]="templateOptions.isYourAssortmentPage"
                  (click)="navigateToShoppingListPage($event)"
                  [ngClass]="{ 'active-title': templateOptions.isYourAssortmentPage }"
                  routerLinkActive="active-link"
                >
                  {{ 'HEADER.ALL_PAGES.YOUR_ASSORTMENT_BUTTON' | translate }}
                </a>
              </div>

              <ng-container
                *ngIf="
                  !(
                    accountInfo?.activeContext !== templateOptions.personalContext &&
                    templateOptions.isPersonalOrderHistoryPage
                  ) && (accountInfo?.isSubsidiary && featureFlagShoppingList | async)
                "
              >
                <span class="account__content__header-tabs__divider"></span>
              </ng-container>
              <div class="list-tab" [ngClass]="{ 'active-tab': templateOptions.isOrderHistoryPage }">
                <a
                  mat-tab-link
                  (click)="navigateToOrderHistoryPage(accountInfo?.activeContext)"
                  [active]="templateOptions.isOrderHistoryPage"
                  [ngClass]="{ 'active-title': templateOptions.isOrderHistoryPage }"
                  routerLinkActive="active-link"
                >
                  {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.TITLE' | translate }}
                </a>
              </div>
              <ng-container
                *ngIf="
                  !(
                    accountInfo?.activeContext !== templateOptions.personalContext &&
                    templateOptions.isPersonalOrderHistoryPage
                  ) && !(accountInfo?.isSubsidiary && featureFlagShoppingList | async)
                "
              >
                <span class="account__content__header-tabs__divider"></span>
              </ng-container>
              <div
                class="list-tab"
                [ngClass]="{ 'active-tab': templateOptions.isBuyAgainPage }"
                *ngIf="
                  !(
                    accountInfo?.activeContext !== templateOptions.personalContext &&
                    templateOptions.isPersonalOrderHistoryPage
                  ) && !(accountInfo?.isSubsidiary && featureFlagShoppingList | async)
                "
              >
                <a
                  mat-tab-link
                  [active]="templateOptions.isBuyAgainPage"
                  (click)="navigateToBuyAgainPage($event)"
                  [ngClass]="{ 'active-title': templateOptions.isBuyAgainPage }"
                  routerLinkActive="active-link"
                >
                  {{ 'PAGES.ACCOUNT.BUY_AGAIN.TITLE' | translate }}
                </a>
              </div>
            </nav>
          </div>
        </ng-container>

        <router-outlet></router-outlet>
      </div>
    </div>
  </app-base-wireframe>
</div>
